import React, { useState, useEffect } from 'react';
import { Typography, Box, IconButton, Grid, Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { deleteBroker } from '../../../redux/slices/operator';
import { Wrapper } from '../../../sections/@dashboard/Trade/watchlist/BuyScriptDrawer';

const DeleteBrokerModal = ({ broker, open, onClose, onUserUpdate }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  // Reset state when modal closes
  useEffect(() => {
    if (!open) {
      setIsLoading(false);
    }
  }, [open]);

  const handleDeleteBroker = async () => {
    try {
      setIsLoading(true);
      const result = await dispatch(deleteBroker(broker._id));
      if (result?.success) {
        // Replace "soft deleted" with "deleted" in the message
        const message = result?.data?.message || 'Broker deleted';
        const cleanMessage = message.replace(/soft\s+deleted/gi, 'deleted');
        enqueueSnackbar(cleanMessage, { variant: 'success' });
        setIsLoading(false);
        if (typeof onUserUpdate === 'function') {
          onUserUpdate();
        }
        onClose();
      } else {
        setIsLoading(false);
        enqueueSnackbar(result?.error || 'Failed to delete broker', { variant: 'error' });
      }
    } catch (err) {
      setIsLoading(false);
      enqueueSnackbar(err?.message || 'Failed to delete broker', { variant: 'error' });
    }
  };

  return (
    <Wrapper
      open={open}
      onClose={onClose}
      children={
        <Box width={{ xs: '100%', sm: '400px' }} marginX={'auto'}>
          <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h4" textAlign="center" pb={2}>
            Delete Broker
          </Typography>
          <Typography variant="body1" textAlign="center" pb={2}>
            Are you sure you want to delete this broker?
          </Typography>
          <Typography variant="body2" textAlign="center" pb={2} color="text.secondary">
            This action cannot be undone.
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <LoadingButton
                variant="contained"
                fullWidth
                size="large"
                onClick={handleDeleteBroker}
                color="error"
                loading={isLoading}
                disabled={!broker?._id}
              >
                Yes
              </LoadingButton>
            </Grid>
            <Grid item xs={6}>
              <Button variant="outlined" fullWidth size="large" onClick={onClose}>
                No
              </Button>
            </Grid>
          </Grid>
        </Box>
      }
    />
  );
};

DeleteBrokerModal.propTypes = {
  broker: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUserUpdate: PropTypes.func,
};

export default DeleteBrokerModal;

